import { useWalletKit } from "@gokiprotocol/walletkit";
import { Box, Button, Grid, makeStyles } from "@material-ui/core";
import * as anchor from "@project-serum/anchor";
import StakeCard from "../../components/StakeCard";
import { PoolType } from "../../constants";
import useStaking from "../../hooks/useStaking";
import useWallet from "../../hooks/useWallet";

const { Program, Provider } = anchor;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    // backgroundColor: theme.palette.background.paper,
    // borderRadius: theme.spacing(0.8),
    // boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    // minHeight: "60vh"
  },
  box: {
    height: "100%",
  },
}));

const StakingPage = () => {
  const classes = useStyles();

  const {
    poolNoLockDetails,
    pool2mLockDetails,
    stakeAccountNoLock,
    stakeAccount2mLock,
  } = useStaking();

  return (
    <Box className={classes.root}>
      <Grid container spacing={2} className={classes.box}>
        <Grid item md={6} xs={12}>
          <StakeCard
            poolDetails={poolNoLockDetails}
            description={"You can unstake from this pool anytime"}
            title={"CYS-NL"}
            poolType={PoolType.NOLOCK}
            stakeAccountDetails={stakeAccountNoLock}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <StakeCard
            poolDetails={pool2mLockDetails}
            description={"Your funds will be locked for 2 months"}
            title={"CYS-2M"}
            poolType={PoolType.TWOLOCK}
            stakeAccountDetails={stakeAccount2mLock}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StakingPage;

{
  /* {stakeAcc?.pool && <>
      <h3>User Account details:</h3>
      <ul>
        <li> Pool {stakeAcc?.pool.toString()}</li>
        <li> User {stakeAcc?.owner.toString()}</li>
        <li> Reward Claimed {parseInt(stakeAcc?.rewardPerTokenComplete.toString()) / 1e6} CYS</li>
        <li> Reward Claimed {stakeAcc?.rewardPerTokenComplete.toString()} CYS</li>
        <li> Reward pending {parseInt(stakeAcc?.rewardPerTokenPending.toString()) / 1e6} CYS</li>
        <li> Balance staked {parseInt(stakeAcc?.balanceStaked.toString()) / 1e6} CYS</li>
        <li> Maturity Time {new Date(parseInt(stakeAcc?.maturityTime.toString()) * 1000).toString()}</li>
      </ul> */
}
{
  /* 
      <h3>Pool Account details:</h3>
      <p>{JSON.stringify(poolAccount.stakingVault)}</p>
      <ul>
        <li> Total Staked {totalStaked} CYS</li>
        <li> Authority {poolAccount?.authority.toString()}</li>
        <li> Paused? {poolAccount?.paused.toString()}</li>
        <li> Staking vault {poolAccount?.stakingVault.toString()}</li>
        <li> Rewards vault {poolAccount?.rewardVault.toString()}</li>
        <li> Reward duration {parseInt(poolAccount?.rewardDuration.toString()) / (60 * 60 * 24)} days</li>
        <li> Reward duration end {new Date(parseInt(poolAccount?.rewardDurationEnd.toString()) * 1000).toString()}</li>
        <li> Lock period {parseInt(poolAccount?.lockPeriod.toString()) / (60 * 60 * 24)} days</li>
        <li> Pool last update time {new Date(parseInt(poolAccount?.lastUpdateTime.toString()) * 1000).toString()}</li>
        <li> Reward Rate {poolAccount?.rewardRate.toString()}</li>
        <li> Reward per token stored {poolAccount?.rewardPerTokenStored.toString()}</li>
        <li> User count {poolAccount?.userStakeCount.toString()}</li>
      </ul> }

    </>*/
}
